import { render, staticRenderFns } from "./categ_info.vue?vue&type=template&id=170e0705&scoped=true&"
import script from "./categ_info.vue?vue&type=script&lang=js&"
export * from "./categ_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170e0705",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('170e0705')) {
      api.createRecord('170e0705', component.options)
    } else {
      api.reload('170e0705', component.options)
    }
    module.hot.accept("./categ_info.vue?vue&type=template&id=170e0705&scoped=true&", function () {
      api.rerender('170e0705', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/categories/category/tabs/categ_info.vue"
export default component.exports